import { render, staticRenderFns } from "./ScheduleChangeNotice.vue?vue&type=template&id=66a70018&scoped=true"
import script from "./ScheduleChangeNotice.vue?vue&type=script&lang=js"
export * from "./ScheduleChangeNotice.vue?vue&type=script&lang=js"
import style0 from "./ScheduleChangeNotice.vue?vue&type=style&index=0&id=66a70018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a70018",
  null
  
)

export default component.exports